import './style.css'

type TIconContainerProps = {
  image_path: string;
}

const IconContainer = ({
  image_path,
}: TIconContainerProps): JSX.Element => {
  return (
    < div className={`icon-container`
    }>
      <img src={image_path} alt="icon" />
    </div >
  );
};

export default IconContainer;